import {initScroll} from './scroll'
import {polyfills} from './polyfills'

initScroll()
polyfills()